import React, { Component } from 'react';
import Header from '../../../Layout/Header'
import { Circle } from '../../TheMoshiDifference/TheMoshiDifference'
class index extends Component {
	render() {
		return (
			<div className="page-case-study">
				<Header
					bg="none"
					title={"Bunbury Turf Club"}
					image={require('./video.jpg')}
					video={{ mp4: require('./video.mp4'), webm: require('./video.webm'), ogv: require('./video.ogv') }}
				/>
				<div className="entry-content">
					
					<div className="container-fluid">
						<h2 className="outline text-center">
							<div className="line"></div>
							<div className="title">Looking for a fresh and engaging presence.</div>
						</h2>
						<div className="row">
							<div className="col-lg-1"></div>
							<div className="col-lg-3">
								<Circle image={require('../../ContactUs/bunbury-turf-club.png')} />
							</div>
							<div className="col-lg-1"></div>
							<div className="col-lg-6">
								<div className="tagline">Moshi Moshi provided marketing consultancy together with a new website, logo refresh, email newsletter and digital and TV campaign.</div>
								<p>Assistance included:</p>
								<ul className="with-icons">
									<li>Marketing Strategy</li>
									<li>Website <a href="https://www.bunburyturfclub.com.au" target="_blank">www.bunburyturfclub.com.au</a></li>
									<li>Custom designed for visual impact</li>
									<li>Responsive design to work on all devices</li>
									<li>Video banner to grab attention</li>
									<li>Animated elements for smooth flow</li>
									<li>Graphic design</li>
									<li>Video and TV Commercial Production</li>
									<li>Google Adwords and Facebook advertising campaigns</li>
									<li>Email Newsletter Design</li>
								</ul>
							</div>
						</div>
					</div>

					<div className="container-fluid example-work">
						<div className="row">
						<div className="col-lg-1"></div>
						<div className="col-lg-6">
							<img src={require('./feature.jpg')} alt="Bunbury Turf Club" width="100%" />
						</div>
							<div className="col-lg-4">
								<img src={require('./example-1.jpg')} alt="Bunbury Turf Club" width="100%" />
								<img src={require('./example-2.jpg')} alt="Bunbury Turf Club" width="100%" />
								<img src={require('./example-3.jpg')} alt="Bunbury Turf Club" width="100%" />
						</div>
							<div className="col-lg-1"></div>
						</div>
					</div>


					

				</div>


			</div>
		);
	}
}

export default index;


// WEBPACK FOOTER //
// ./src/Pages/WhatWeveDone/BunburyTurfClub/index.js